import * as React from "react";
import { forwardRef } from "react";
const SvgRunning = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 6, r: 6, fill: "#59C9A5" }));
const ForwardRef = forwardRef(SvgRunning);
export default ForwardRef;
